import { render } from "./WCCartDrawerGiftCardItem.vue?vue&type=template&id=34e21b0e&scoped=true"
import script from "./WCCartDrawerGiftCardItem.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerGiftCardItem.vue?vue&type=script&lang=js"

import "./WCCartDrawerGiftCardItem.vue?vue&type=style&index=0&id=34e21b0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e21b0e"]])

export default __exports__